import React from 'react';
import { withApollo } from '@apollo/client/react/hoc';
import { Route, Switch, Redirect } from 'react-router-dom';
import { compose } from 'recompose';
import PageWithNavigation from '../../Navigation/PageWithNavigation';
import GlobalErrorBoundary from '../GlobalErrorBoundary';
// eslint-disable-next-line @typescript-eslint/tslint/config
import routeConfig from '../routes';
import LastLocationProvider from './LastLocationProvider';
import RedirectIfAuthenticated from './RedirectIfAuthenticated';
import { DefaultRoutes, RedirectIfFlagDisabled } from './routes';
import RedirectToSearch from './RedirectToSearch';
import Route404 from './Route404';

import { RouterProps } from './types';

const Router = ({
  routes = routeConfig,
  renderIfAuthenticating,
  renderIfUnauthorized,
}: RouterProps) => (
  <GlobalErrorBoundary>
    <LastLocationProvider>
      <PageWithNavigation routeConfigs={routeConfig}>
        <Switch>
          {routes.map((route, key) => {
            if (route.redirectIfAuthenticated !== undefined) {
              return (
                <RedirectIfAuthenticated
                  key={key}
                  renderIfAuthenticating={renderIfAuthenticating}
                  {...route}
                />
              );
            }

            if (
              route.redirectIfFlagDisabled?.flag &&
              route.redirectIfFlagDisabled?.redirectTo
            ) {
              return (
                <Route
                  key={key}
                  path={route.path}
                  exact={route.exact}
                  render={routerProps => (
                    <RedirectIfFlagDisabled
                      route={route}
                      computedMatch={routerProps.match}
                      renderIfAuthenticating={renderIfAuthenticating}
                      renderIfUnauthorized={renderIfUnauthorized}
                      {...routerProps}
                    />
                  )}
                />
              );
            }

            if (route.redirectTo) {
              return (
                <Route key={key} path={route.path} exact={route.exact}>
                  <Redirect to={route.redirectTo} />
                </Route>
              );
            }

            return (
              <Route
                key={key}
                path={route.path}
                exact={route.exact}
                render={routerProps => (
                  <DefaultRoutes
                    route={route}
                    computedMatch={routerProps.match}
                    renderIfAuthenticating={renderIfAuthenticating}
                    renderIfUnauthorized={renderIfUnauthorized}
                    {...routerProps}
                  />
                )}
              />
            );
          })}
          <Route component={Route404} />
        </Switch>
        <RedirectToSearch />
      </PageWithNavigation>
    </LastLocationProvider>
  </GlobalErrorBoundary>
);

export default compose<RouterProps, Omit<RouterProps, 'client'>>(withApollo)(
  Router,
);
